module.exports = __webpack_public_path__ + "static/media/profile-bg.7958f301.jpg";